module.exports = __webpack_public_path__ + "static/img/ikonaScenariusz-OFF.c9f9fd61.png";